import { useMemo } from 'react';
import { useQuery } from '@ts-core/lib/apollo';

import { Message } from '../types';

import { getMessagesQuery, GetMessagesQueryResult } from '../graphql/queries/getMessagesQuery';

export interface NotificationsHookInput {
  selectedMessageId?: string;
}

export interface NotificationsHookPayload {
  loading: boolean;
  unseen: number;
  messages?: Message[];
  previewMessagesList: Message[];

  selectedMessage?: Message;
}

export default function useMessages(input: NotificationsHookInput = {}): NotificationsHookPayload {
  const { selectedMessageId } = input;

  const { data, loading } = useQuery<GetMessagesQueryResult>(getMessagesQuery);

  const messages = data?.messagesPayload?.messages;

  const previewMessagesList = useMemo(() => {
    return data?.messagesPayload?.messages?.slice(0, Math.min(5, data?.messagesPayload?.messages?.length || 0)) || [];
  }, [data]);

  const selectedMessage = useMemo<Message | undefined>(() => {
    if (!messages) {
      return undefined;
    }
    let message: Message | undefined;
    if (selectedMessageId) {
      message = messages.find((m) => m.id === selectedMessageId);
    }
    if (!message) {
      message = messages[0];
    }
    return message;
  }, [selectedMessageId, messages]);

  return {
    loading,
    messages,
    unseen: data?.messagesPayload?.unseen ?? 0,
    previewMessagesList,

    selectedMessage,
  };
}
